import { render, staticRenderFns } from "./AccountingFec.vue?vue&type=template&id=6dcae1b3&"
import script from "./AccountingFec.vue?vue&type=script&lang=js&"
export * from "./AccountingFec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports